import {
    Column,
    Entity,
    Index,
    JoinColumn,
    OneToMany,
    OneToOne,
    PrimaryGeneratedColumn, Relation,
} from "typeorm";
import { Project } from "./Project";
import { PlatformUser } from "./PlatformUser";

@Index("writer_profile_pkey", ["id"], { unique: true })
@Index("writer_profile_unique_idx", ["platformUserId"], { unique: true })
@Entity("writer_profile")
export class WriterProfile {
  @PrimaryGeneratedColumn({ type: "bigint", name: "id" })
  id!: string;

  //this was a string?
  @Column("bigint", { name: "platform_user_id" })
  platformUserId: number;

  @Column("text", { name: "bio_sketch", nullable: true })
  bioSketch: string | null;

  @OneToMany((type) => Project, (project) => project.writerProfile)
  projects!: Project[];

  @OneToOne((type) => PlatformUser, (platformUser) => platformUser.writerProfile)
  @JoinColumn([{ name: "platform_user_id", referencedColumnName: "id" }])
  platformUser!: PlatformUser;
}
